/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'yes' }, { id: 'sometimes' }, { id: 'no' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-women-styling-products"
      progress={72}
      field="hairstyleWomenStylingProducts"
      setter="setHairstyleWomenStylingProducts"
      ns="hairstyleWomenStylingProducts"
      imageName="hairstyleWomenStylingProducts"
      options={OPTIONS}
    />
  );
}

export default Page;
